import React from "react";
import { useForm } from "react-hook-form";
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

export interface ProcessWheelFormValues {
  name: string;
  description: string;
}

interface ProcessWheelFormProps {
  initialData: ProcessWheelFormValues;
  loading?: boolean;
  readOnly?: boolean;
  onSubmit?: (values: ProcessWheelFormValues) => void;
}

const ProcessWheelForm: React.FC<ProcessWheelFormProps> = ({
  initialData,
  loading = false,
  readOnly = false,
  onSubmit,
}) => {
  const formMethods = useForm<ProcessWheelFormValues>({
    defaultValues: initialData,
  });

  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
    watch,
  } = formMethods;

  const nameValue = watch("name");

  const handleFormSubmit = (data: ProcessWheelFormValues) => {
    onSubmit?.(data);
  };

  return (
    <Form {...formMethods}>
      <form className="space-y-4" onSubmit={handleSubmit(handleFormSubmit)}>
        <FormField
          control={control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Name *</FormLabel>
              <FormControl>
                <Input disabled={readOnly} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="description"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Description</FormLabel>
              <FormControl>
                <Textarea disabled={readOnly} rows={4} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        {!readOnly && (
          <div className="flex justify-end">
            <Button
              disabled={loading || isSubmitting || !nameValue?.trim()}
              type="submit"
            >
              {loading || isSubmitting ? "Saving..." : "Save"}
            </Button>
          </div>
        )}
      </form>
    </Form>
  );
};

export default ProcessWheelForm;
